import { render, staticRenderFns } from "./admin-video-analysis.vue?vue&type=template&id=3cbf34fe"
import script from "./admin-video-analysis.vue?vue&type=script&lang=js"
export * from "./admin-video-analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports